import { useThemeMediaQuery } from '@fuse/hooks';
import { DeleteOutlineOutlined, Edit } from '@mui/icons-material';
import ConfirmDeleteModalWindow from 'app/shared-components/confirmDeleteModalWindow';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAbsoluteFileUrl } from 'src/app/helpers/utils';

const Skill = ({ skill, onEdit, onRemove }) => {
  const { i18n } = useTranslation('translations');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [skillId, setSkillId] = useState(null);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));
  const handleGetById = () => {
    onEdit(skill);
  };

  const handleDeleteSkill = () => {
    onRemove(skill);
  };

  const handleShowModal = (skillId) => {
    setIsOpenModal(true);
    setSkillId(skillId);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <div
      key={skill.id}
      className="group w-[90px] p-5 text-center border-1 rounded-6  m-4"
    >
      <div className="flex justify-between items-center gap-6">
        <Edit
          className={`text-[#2196f3]  cursor-pointer text-16 ${
            !isMobile && 'opacity-0 group-hover:opacity-100 transition-opacity duration-200'
          } `}
          onClick={handleGetById}
        />
        <DeleteOutlineOutlined
          onClick={() => handleShowModal(skill.id)}
          className={`text-red cursor-pointer text-16 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
            !isMobile && 'opacity-0 group-hover:opacity-100 transition-opacity duration-200'
          }`}
        />
      </div>
      <img src={getAbsoluteFileUrl(skill.pictureUrl)} alt={skill.id} className="w-40 h-40 m-auto" />
      <p className="mt-5 text-12">{skill.name}</p>

      {isOpenModal && (
        <ConfirmDeleteModalWindow
          setIsOpenModal={setIsOpenModal}
          open={isOpenModal}
          onClose={handleCloseModal}
          deleteMessage={() => handleDeleteSkill(skillId)}
          modalTitle="AreYouSureToDeleteSkill"
        />
      )}
    </div>
  );
};

export default Skill;
